import { AllTables } from "@swivl-mono/types";
import { SelectableOption } from "@swivl-mono/ui";

import { Member } from "../Member/Member.Current";

export class TablesModel {
  static reset() {}
  static getTablesForBotAsOptions(): SelectableOption[] {
    return Object.values(AllTables)
      .filter((table) => {
        if (!table.orgId || table.orgId === Member.orgId) {
          return true;
        }
        return false;
      })
      .map((table) => {
        return {
          label: table.name,
          value: table.id
        };
      });
  }

  static tableHadRequiredFields(tableId: string): boolean {
    const table = AllTables[tableId];
    if (table) {
      const columns = Object.values(table.mapping);
      for (let i = 0; i < columns.length; i++) {
        const column = columns[i];
        if (column.isRequired) {
          return true;
        }
      }
    }
    return false;
  }
}
